import { useTranslate } from "@similarweb/i18n-provider";
import { Stack } from "@similarweb/ui-components/foundations";

import { formatNumberWithComa } from "app/pages/sales-intelligence/utils/leads";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { StyledInfoCellFlex, StyledMetaCaption, StyledMetaValue } from "./styles";

const EMPTY_METRIC = "—";

type MetricCaptionKey = string;

type DealSignalFileMetricProps = {
    readonly value?: number;
    readonly captionKey: MetricCaptionKey;
    readonly emptyLabel: string;
};

export const DealSignalFileMetric = ({ value, captionKey, emptyLabel }: DealSignalFileMetricProps) => {
    const { translate } = useTranslate();

    const isEmpty = is.undefined(value);

    return (
        <StyledInfoCellFlex
            alignItems="center"
            justifyContent="center"
        >
            <Stack
                alignItems="center"
                justifyContent="center"
            >
                <StyledMetaValue
                    aria-label={isEmpty ? translate(emptyLabel) : undefined}
                    data-automation="signal-recommender-file-metric-value"
                >
                    {isEmpty ? EMPTY_METRIC : formatNumberWithComa(value)}
                </StyledMetaValue>
                <StyledMetaCaption>{translate(captionKey)}</StyledMetaCaption>
            </Stack>
        </StyledInfoCellFlex>
    );
};
